import { JuloUpdateEntry } from "./types"

export const fullApprovalDiscountEntry: JuloUpdateEntry = {
  slug: "2026-10-22-full-approval-discount",
  date: "2026-10-22",
  title: "Rabatt när kunden godkänner hela förslaget",
  description:
    "I sista steget i besiktningen finns nu **Orderrabatt vid fullt godkännande** under de tre prickarna. Ange rabatten i %, kr eller som nytt pris. Den dras av från hela ordern, men bara om kunden godkänner allt ni rekommenderar. Rabatten ersätter övriga orderrabatter.\n\nKunden ser erbjudandet direkt i serviceförslaget:\n\n- **Toppskick och Trafiksäker** – rabatten visas på Toppskick, med det ordinarie priset överstruket. Trafiksäker får ingen rabatt, och tar kunden bort något under Anpassa visar kortet i stället vilken rabatt kunden får genom att godkänna allt.\n- **Ett förslag** – när allt ska åtgärdas nu, eller allt kan vänta, visas ett förslag med rabatten högst upp.\n\nRabatten syns som en egen rad i totalen, och när kunden godkänner hamnar den på ordern som en vanlig orderrabatt. Godkänner kunden inte allt försvinner den.",
  images: [
    {
      src: "/julo-updates/2026-10-22-full-approval-discount/1-meny.png",
      alt: "Menyn under de tre prickarna i serviceförslaget, med Orderrabatt vid fullt godkännande mellan Rabatter och Visa kvitto.",
    },
    {
      src: "/julo-updates/2026-10-22-full-approval-discount/2-rabatt.png",
      alt: "Rutan Orderrabatt vid fullt godkännande med valen %, kr och Nytt pris. 10 % är ifyllt och under fältet står Nytt pris 2 237 kr (ordinarie 2 486 kr).",
    },
    {
      src: "/julo-updates/2026-10-22-full-approval-discount/3-toppskick.png",
      alt: "Kundens serviceförslag med Toppskick valt. På kortet står −10 % rabatt om du godkänner hela förslaget och priset 2 237 kr bredvid överstrukna 2 486 kr. Trafiksäker kostar 2 030 kr utan rabatt.",
    },
    {
      src: "/julo-updates/2026-10-22-full-approval-discount/4-ett-forslag.png",
      alt: "Ett serviceförslag utan nivåer, med rutan Du får 15 % rabatt om du godkänner hela förslaget högst upp och en rabattrad på −373 kr i totalen.",
    },
  ],
}
